/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import axios from "axios";

const qs = require("qs");

export default {
  state: {
    poolData: [],
    destinationData: [],
  },
  getters: {
    getPoolData(state) {
      return state.poolData;
    },
    getDestinationData(state) {
      return state.destinationData;
    },
  },
  mutations: {
    ADD_POOL_DATA(state, data) {
      state.poolData = data;
    },
    ADD_DESTINATION_DATA(state, data) {
      state.destinationData = data;
    },
  },
  actions: {
    LOAD_POOL_DATA({ commit, rootState }) {
      commit("SET_DATA_SCHEDULE", "LOADING");
      return axios
        .post(
          `${process.env.VUE_APP_API_URL}/get_geofences`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
          })
        )
        .then((response) => {
          if (response !== null) {
            const geofences = [
              ...response.data.data[rootState.clientid][0].geofences,
              ...response.data.data[rootState.clientid][2].geofences,
            ];
            commit("ADD_POOL_DATA", geofences);
            commit("SET_DATA_SCHEDULE", "LOADED");
          }
        })
        .catch((error) => {
          commit("SET_DATA_SCHEDULE", "ERROR");
        });
    },
    LOAD_DESTINATION_DATA({ commit, rootState }) {
      commit("SET_DATA_SCHEDULE", "LOADING");
      return axios
        .post(
          `${process.env.VUE_APP_API_URL}/get_geofences`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
          })
        )
        .then((response) => {
          if (response !== null) {
            const geofences = [
              ...response.data.data[rootState.clientid][1].geofences,
              ...response.data.data[rootState.clientid][2].geofences,
            ];
            commit("ADD_DESTINATION_DATA", geofences);
            commit("SET_DATA_SCHEDULE", "LOADED");
          }
        })
        .catch((error) => {
          commit("SET_DATA_SCHEDULE", "ERROR");
        });
    },
  },
};
